// extracted by mini-css-extract-plugin
export default {"card":"w2-z"};